import { Type } from "@angular/core";
import { StateOperator, getValue, setValue } from "@ngxs/store";
import { patch } from "@ngxs/store/operators"; // Remove PatchSpec from here
import { Store } from "./core";

export function patchState<T>(selector: Type<any>, patchObject: Partial<T>): StateOperator<any> {
    return (state: any): any => {
        const path: string = Store.getStateMetadata(selector).path;
        // Fix: Cast patchObject to any to bypass the strict NoInfer<ɵPatchSpec<T>> check
        const patchedState = patch<T>(patchObject as any)(getValue(state, path));
        return setValue(state, path, patchedState);
    };
}